import sensorsdata from 'sa-sdk-javascript';
import { env } from '../libs/env';
import User from '../libs/user';

// doc 地址 https://www.sensorsdata.cn/manual/js_sdk.html
sensorsdata.init({
  server_url: `https://sensorapi.666visa.cn/sa?project=${env ? 'default' : 'production'}`,
  name: 'sensorsdata',
  heatmap_url: '/static/js/heatmap.min.js',
  heatmap: {
    // 是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
    clickmap: 'default',
    // 是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
    scroll_notice_map: 'default',
  },
  is_track_single_page: true, // 表示是否开启单页面自动采集 $pageview 功能，SDK 会在 url 改变之后自动采集web页面浏览事件 $pageview
  show_log: false,
});

sensorsdata.registerPage({
  platform_type: 'PC',
  peer_name() {
    return User.peer.peer_name;
  },
  visa_peer_id() {
    return User.peer.visa_peer_id;
  },
  release_group() {
    // 0老页面 1新页面
    return User.is_grayscale_peer ? 'new_home_page' : 'old_home_page';
  },
});

sensorsdata.quick('autoTrack');



// WEBPACK FOOTER //
// ./src/config/sensors-data.config.js